import { render, staticRenderFns } from "./file-dropzone.vue?vue&type=template&id=27d3dbde"
import script from "./file-dropzone.vue?vue&type=script&lang=js"
export * from "./file-dropzone.vue?vue&type=script&lang=js"
import style0 from "./file-dropzone.vue?vue&type=style&index=0&id=27d3dbde&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sipinor/public_html/system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27d3dbde')) {
      api.createRecord('27d3dbde', component.options)
    } else {
      api.reload('27d3dbde', component.options)
    }
    module.hot.accept("./file-dropzone.vue?vue&type=template&id=27d3dbde", function () {
      api.rerender('27d3dbde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/file-dropzone.vue"
export default component.exports